import { TenantState } from './tenant.reducer';

export const tenantHelpers = {
  store: null,
  getIntegrationType: () => getIntegrationType(tenantHelpers.store),
  getProductName: () => getProductName(tenantHelpers.store),
  getCompanyName: () => getCompanyName(),
}

function getIntegrationType(store) {
  const { tenant } = store ? store.getState() : { tenant: new TenantState({}) };
  const { currentTenant } = tenant;
  const { integrationType } = currentTenant || { integrationType: '' };

  return integrationType;
}

/** currently just returns the name Connect, but has enough information to switch based on integration type */
function getProductName(store) {
  return "Connect";
}

function getCompanyName() {
  return "Bonterra";
}



// WEBPACK FOOTER //
// src/tenantInfo/tenant-helpers.js